var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 37,
    viewBox: "0 0 41 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_72_1043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1351 0.0392761L22.4907 11.5811L25.3843 4.77134L38.1351 0.0392761Z",
    fill: "#E2761B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02051 0.0392761L17.5391 11.6903L14.7871 4.77134L2.02051 0.0392761Z",
    fill: "#E4761B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5063 26.7933L28.3398 33.1347L37.2549 35.5706L39.8179 26.934L32.5063 26.7933Z",
    fill: "#E4761B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.369629 26.934L2.91678 35.5706L11.8318 33.1347L7.6654 26.7933L0.369629 26.934Z",
    fill: "#E4761B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3284 16.079L8.84375 19.8123L17.6955 20.2028L17.3815 10.7536L11.3284 16.079Z",
    fill: "#E4761B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.827 16.079L22.6956 10.6444L22.4907 20.2028L31.3274 19.8123L28.827 16.079Z",
    fill: "#E4761B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8315 33.1347L17.1458 30.5573L12.5546 26.996L11.8315 33.1347Z",
    fill: "#E4761B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0098 30.5573L28.3398 33.1347L27.601 26.996L23.0098 30.5573Z",
    fill: "#E4761B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3398 33.1347L23.0098 30.5573L23.4346 34.0093L23.3871 35.4614L28.3398 33.1347Z",
    fill: "#D7C1B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8315 33.1347L16.7842 35.4614L16.7526 34.0093L17.1458 30.5573L11.8315 33.1347Z",
    fill: "#D7C1B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8625 24.7164L12.4287 23.4199L15.5573 21.9984L16.8625 24.7164Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.293 24.7164L24.5982 21.9984L27.7426 23.4199L23.293 24.7164Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8315 33.1347L12.5861 26.7933L7.66504 26.934L11.8315 33.1347Z",
    fill: "#CD6116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.585 26.7933L28.3396 33.1347L32.506 26.934L27.585 26.7933Z",
    fill: "#CD6116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3274 19.8123L22.4907 20.2028L23.3087 24.7164L24.6139 21.9984L27.7583 23.4199L31.3274 19.8123Z",
    fill: "#CD6116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4287 23.4199L15.5731 21.9984L16.8625 24.7164L17.6955 20.2028L8.84375 19.8123L12.4287 23.4199Z",
    fill: "#CD6116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84375 19.8123L12.5545 26.996L12.4287 23.4199L8.84375 19.8123Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7585 23.4199L27.6011 26.996L31.3277 19.8123L27.7585 23.4199Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6958 20.2028L16.8628 24.7164L17.9006 30.0418L18.1364 23.0293L17.6958 20.2028Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4909 20.2028L22.0669 23.0136L22.2552 30.0418L23.3088 24.7164L22.4909 20.2028Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.309 24.7164L22.2554 30.0418L23.01 30.5572L27.6012 26.996L27.7586 23.4199L23.309 24.7164Z",
    fill: "#F6851B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4287 23.4199L12.5545 26.996L17.1457 30.5572L17.9003 30.0418L16.8625 24.7164L12.4287 23.4199Z",
    fill: "#F6851B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3871 35.4614L23.4345 34.0093L23.0414 33.6651H17.1141L16.7526 34.0093L16.7842 35.4614L11.8315 33.1347L13.5608 34.5397L17.0667 36.9607H23.0888L26.6106 34.5397L28.3398 33.1347L23.3871 35.4614Z",
    fill: "#C0AD9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0096 30.5573L22.2549 30.0418H17.9002L17.1456 30.5573L16.7524 34.0093L17.1139 33.6651H23.0412L23.4344 34.0093L23.0096 30.5573Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7958 12.3307L40.1318 5.95868L38.1353 0.0392761L23.0098 11.1905L28.8271 16.0789L37.05 18.4686L38.8741 16.3603L38.0878 15.7984L39.3456 14.6582L38.371 13.9086L39.6287 12.9554L38.7958 12.3307Z",
    fill: "#763D16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0395508 5.95868L1.37562 12.3307L0.526832 12.9554L1.78459 13.9086L0.825845 14.6582L2.0836 15.7984L1.29731 16.3603L3.10563 18.4686L11.3285 16.0789L17.1458 11.1905L2.02032 0.0392761L0.0395508 5.95868Z",
    fill: "#763D16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0501 18.4686L28.8272 16.0789L31.3277 19.8123L27.6011 26.996L32.5063 26.9339H39.8179L37.0501 18.4686Z",
    fill: "#F6851B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3287 16.0789L3.10584 18.4686L0.369629 26.9339H7.6654L12.5548 26.996L8.84405 19.8123L11.3287 16.0789Z",
    fill: "#F6851B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4911 20.2028L23.01 11.1905L25.4005 4.77136H14.7871L17.146 11.1905L17.6958 20.2028L17.8848 23.0451L17.9006 30.0418H22.2553L22.287 23.0451L22.4911 20.2028Z",
    fill: "#F6851B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_1043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.1714,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.d7c19b7b593bd0af1f1dbe05e51d5254.svg";
export { ForwardRef as ReactComponent };